"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekDay = void 0;
var WeekDay;
(function (WeekDay) {
    WeekDay["MONDAY"] = "mon";
    WeekDay["TUESDAY"] = "tue";
    WeekDay["WEDNESDAY"] = "wed";
    WeekDay["THURSDAY"] = "thu";
    WeekDay["FRIDAY"] = "fri";
    WeekDay["SATURDAY"] = "sat";
    WeekDay["SUNDAY"] = "sun";
})(WeekDay = exports.WeekDay || (exports.WeekDay = {}));
//# sourceMappingURL=offering-schedule-header.dto.js.map